import React from 'react';
import { observer } from 'mobx-react';

// Translations
import translate from '../Translate.js';

const MessageContext = observer(class MessageContext extends React.Component {
  render() {
    return (
      <aside className="thread__context">
        <h4 className="thread__context__hdg">{this.props.title}</h4>

        <ul className="data--alt">
          {this.props.data.map(
            (data, i) =>
            <li key={i}>
              <strong>{data.title}</strong>
              <p>{data.value}</p>
            </li>
          )}
        </ul>
      </aside>
    )
  }
})

export default translate('MessageContext')(MessageContext);


// WEBPACK FOOTER //
// ./src/app/components/Messages/MessageContext.js